import ReporteBase from "./ReportePage.js";

const ReporteCotizacion = () => {
    return (
        <ReporteBase
            titulo="Lista Cotizaciones"
            variant="COTIZACION"
            unificadoDinar={true}
        />
    );
};

export default ReporteCotizacion;